import { first } from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../Button';
import { ListSelectionType, VirtualizedList } from '../../../List';
import { ResponsiveDialog } from '../../../ResponsiveDialog/ResponsiveDialog';
import { SearchInput } from '../../../SearchInput/SearchInput';
import './SelectTeamsAssignmentDialog.scss';

export interface SelectTeamsAssignmentListItemProps {
  assignmentId: string;
  assignmentName: string;
  courseName: string;
}

export interface SelectTeamsAssignmentDialogProps {
  open: boolean;
  assignments: SelectTeamsAssignmentListItemProps[];
  onAssignmentSelected: (assignmentId: string, assignmentName: string) => void;
  onCancelClick: () => void;
}

export const SelectTeamsAssignmentDialog: React.FC<
  SelectTeamsAssignmentDialogProps
> = props => {
  const { t } = useTranslation();
  const [filterQuery, setFilterQuery] = useState<string>('');
  const [selectedAssignment, setSelectedAssignment] =
    useState<SelectTeamsAssignmentListItemProps | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number[]>([]);

  const filterdAssignmentListItems = props.assignments.filter(assignment => {
    return (
      assignment.assignmentName === '' ||
      assignment.assignmentName.includes(filterQuery)
    );
  });

  const assignmentListItems = filterdAssignmentListItems.map(assignment => ({
    label:
      assignment.assignmentName ||
      t('classbook:teamassignmentdialog:empty_assignment_plan', { defaultValue: 'Kein Titel vorhanden' }),
    content: assignment.courseName,
  }));

  const handleSelectionChange = (selected: number[]) => {
    const selectedIdx = first(selected);
    if (selectedIdx === undefined || selectedIdx === -1) {
      return;
    }
    const selectedAssignment = filterdAssignmentListItems[selectedIdx];
    setSelectedAssignment(selectedAssignment);
    setSelectedIndex([selectedIdx]);
  };

  const handleFilterQueryChange = (query: string) => {
    setFilterQuery(query);
  };

  return (
    <ResponsiveDialog
      open={props.open}
      className="selectTeamsAssignmentDialog"
      header={t('classbook:teamassignmentdialog:header', { defaultValue: 'Teams Aufgabe auswählen' })}
      primaryAction={
        <Button
          appearance="primary"
          disabled={selectedAssignment === null}
          onClick={() => {
            if (selectedAssignment !== null) {
              props.onAssignmentSelected(
                selectedAssignment.assignmentId,
                selectedAssignment.assignmentName,
              );
            }
          }}
        >
          {t('classbook:teamassignmentdialog:select_homework', { defaultValue: 'Aufgabe auswählen' })}
        </Button>
      }
      secondaryAction={
        <Button onClick={props.onCancelClick}>
          {t('cancel', { defaultValue: 'Abbrechen' })}
        </Button>
      }
    >
      <div className="flex flex-col flex-1 items-stretch gap-2 wrapper">
        <SearchInput
          appearance="filled-darker"
          className="w-full"
          placeholder={t('classbook:teamassignmentdialog:filtern', { defaultValue: 'Aufgabe suchen...' })}
          value={filterQuery}
          onChange={(_, data) => {
            if (data) {
              handleFilterQueryChange(data.value);
            }
          }}
          onClear={() => handleFilterQueryChange('')}
        />
        <VirtualizedList
          entries={assignmentListItems}
          selectedEntries={selectedIndex}
          selectionType={ListSelectionType.Single}
          onSelectionChange={handleSelectionChange}
        />
      </div>
    </ResponsiveDialog>
  );
};
